import { mapState } from 'vuex';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';

export default {
  computed: {
    ...mapState({
      gameId: state => state.gameId,
      showChannel: state => state.showChannel
    }),
    // 切换旧版的
    showSwitchVersion() {
      return [191].includes(+this.gameId);
    },
    headerShowSwitchVersion() {
      return (
        this.showSwitchVersion && this.$route.meta.pageName === 'userCenterPage'
      );
    },
    // 切换新版3.5
    showSwitchVersionOfficialTopupNew() {
      return [390, 429].includes(+this.gameId) && !this.showChannel;
    }
  },
  methods: {
    // 切换旧版的
    switchVersion() {
      window.location.href = getGlobalGetGotoLink({
        link: window.location.href
          .replace('officialTopup.html', 'officialStore.html')
          .replace(window.location.hash, '#/')
      });
    },
    // 切换新版3.5
    switchVersionOfficialTopupNew() {
      window.location.href = getGlobalGetGotoLink({
        link: window.location.href
          .replace('officialTopup.html', 'officialTopupNew.html')
          .replace(window.location.hash, '#/')
      });
    }
  }
};
